<template>
  <el-dialog
    title="批量修改分类"
    :visible.sync="batchDialogShow"
    width="500px"
    :before-close="handleClose"
  >
    <el-form
      :model="typeForm"
      :rules="rules"
      ref="typeForm"
      label-width="100px"
      class="demo-typeForm"
    >
      <el-form-item label="一级分类" prop="materialTopTypeId">
        <el-select
          v-model="typeForm.materialTopTypeId"
          placeholder="请选择"
          size="mini"
        >
          <el-option
            v-for="item in oneOptions"
            :key="item.id"
            :label="item.typeName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级分类" prop="materialMiddleTypeId">
        <el-select
          v-model="typeForm.materialMiddleTypeId"
          placeholder="请选择"
          size="mini"
          :disabled="isTopEdit"
        >
          <el-option
            v-for="item in twoOptions"
            :key="item.id"
            :label="item.typeName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="三级分类" prop="materialDownTypeId">
        <el-select
          v-model="typeForm.materialDownTypeId"
          placeholder="请选择"
          size="mini"
          :disabled="isMiddEdit"
        >
          <el-option
            v-for="item in threeOptions"
            :key="item.id"
            :label="item.typeName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSuccessEdit">确认修改</el-button>
      <el-button @click="handleClose">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { selectPageUpdate } from "@/api/mass/mass.js";
export default {
  props: {
    batchDialogShow: {
      type: Boolean,
      default: false,
    },
    emitTypeList: {
      type: Array,
      default: [],
    },
    multipleSelectionData: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      typeForm: {
        materialTopTypeId: "",
        materialMiddleTypeId: "",
        materialDownTypeId: "",
      },
      rules: {
        materialTopTypeId: [
          { required: true, message: "请选择一级分类", trigger: "change" },
        ],
      },
      newTypeList:[],
      oneOptions: [],
      twoOptions: [],
      threeOptions: [],
      isTopEdit: true,
      isMiddEdit: true
    };
  },
  watch: {
    batchDialogShow(newValue){
      if(newValue){
        this.init();
      }
    },
    emitTypeList: {
      handler(newVal) {
        if(!Array.isArray(newVal) || newVal.length <= 0) return;
        this.newTypeList = [];
        this.oneOptions = newVal[0];
        this.twoOptions = newVal[1];
        this.threeOptions = newVal[2];
      },
      deep: true,
      immediate: true
    },
    'typeForm.materialTopTypeId': {
      handler(newVal) {
        if(newVal){
          const typeList = this.oneOptions.find(item=> item.id == newVal);
          if (Array.isArray(typeList.children) && typeList.children.length > 0) {
            this.filterType(typeList.children , 1);
          }else{
            this.$nextTick(()=>{
              this.twoOptions = [];
              this.threeOptions = [];
            })
          }
          this.isTopEdit = false;
        }else{
          this.oneOptions = this.emitTypeList[0];
          this.twoOptions = this.emitTypeList[1];
          this.threeOptions = this.emitTypeList[2];
          this.isTopEdit = true;
        }
        this.$set(this.typeForm, 'materialMiddleTypeId', "");
        this.$set(this.typeForm, 'materialDownTypeId', "");
      },
      deep:true
    },
    'typeForm.materialMiddleTypeId': {
      handler(newVal) {
        if(newVal){
          const typeList = this.twoOptions.find(item=> item.id == newVal);
          if (Array.isArray(typeList.children) && typeList.children.length > 0) {
          this.filterType(typeList.children , 2);
          }else{
            this.$nextTick(()=>{
              this.threeOptions = [];
            })
          }
          this.isMiddEdit = false;
        }else{
          this.oneOptions = this.emitTypeList[0];
          this.twoOptions = this.emitTypeList[1];
          this.threeOptions = this.emitTypeList[2];
          this.isMiddEdit = true;
        }
        this.$set(this.typeForm, 'materialDownTypeId', "");
      },
      deep:true
    }
  },
  methods: {
    init() {
      this.typeForm.materialTopTypeId = "";
      this.typeForm.materialMiddleTypeId = "";
      this.typeForm.materialDownTypeId = "";
    },
    handleClose(done) {
      this.$emit("update:batchDialogShow", false);
    },
    handleSuccessEdit() {
      let ids = []
      this.multipleSelectionData.map(item=> ids.push(item.id))
      let selectParams = {
        isSelectAll: 0,
        ids,
        topTypeId: this.typeForm.materialTopTypeId,
        middleTypeId: this.typeForm.materialMiddleTypeId,
        downTypeId: this.typeForm.materialDownTypeId,
        notIds: []
      }
      selectPageUpdate(selectParams).then(res => {
        if(res.error.code == 200) {
          this.$message({
            type: "success",
            message: "修改成功！!",
          });
          this.handleClose()
          this.$emit("getData")
        }
      })
    },
    // 过滤分类条件
    filterType(typeList, level) {
      this.newTypeList = [];
      if (level == 1) {
        const twoOptions = [] , threeOptions =[];
        this.recursiveMap(typeList,this.newTypeList, 2);
          this.newTypeList.forEach(options => {
            if(options.level == 2) {
              twoOptions.push(options.item);
            }else {
              threeOptions.push(options.item);
            }
          })
          this.$nextTick(()=>{
            this.twoOptions = [ ...twoOptions];
            this.threeOptions = [...threeOptions];
          })
      } else {
        this.$nextTick(()=>{
          this.threeOptions= [...typeList];
        })
      }
    },
    recursiveMap(nestedList, newList, level = 1) {
      nestedList.forEach(item => {
        newList.push({item, level});
          if (Array.isArray(item.children) && item.children.length > 0) {
            this.recursiveMap(item.children, newList,  level + 1);
          }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
